import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "draggable"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "      ", -1)

export interface propsComponent {
  isPreview: boolean;
}
import { useAttrs, computed, withDefaults } from "vue";

import { defineComponent, ref } from "vue";
const __default__ = defineComponent({
  name: "VZDivider",
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isPreview: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { isPreview: boolean }

const attrs = useAttrs();

const style = computed(() => {
  return !props.isPreview ? "pointer-events: none" : "";
});
const restAttr = computed(() => {
  const { id, draggable, ...rest } = attrs;
  if (rest.style && rest.style.defaultBorder === "true !important") {
    rest.style.borderColor = "";
    rest.style.borderWidth = "";
    rest.style.borderStyle = "";
    rest.style.padding = "";
    rest.style.margin = "";
    rest.borderColor = "";
    rest.borderWidth = "";
    rest.borderStyle = "";
    rest.padding = "";
    rest.margin = "";
  }

  return rest;
});
const isDraggable = computed(() => {
  return attrs?.draggable ?? false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "VZ_TABLE_BUTTON",
    id: _unref(attrs).id,
    draggable: _unref(isDraggable)
  }, [
    _hoisted_2,
    _createElementVNode("hr", _mergeProps(_unref(restAttr), { style: _unref(style) }), null, 16)
  ], 8, _hoisted_1))
}
}

})